var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtmlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0125 45.0016L0 0H44.0875L40.0719 44.9953L22.0156 49.9984L4.0125 45.0016Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6328 42.1297L40.0656 3.67969H22.0437V46.175L36.6328 42.1297Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.025 9.19849H8.20312L9.69219 25.8891H22.0438V20.3704H14.7406L14.2359 14.7188H22.0438V9.19849H22.025ZM22.0438 34.686L22.0203 34.6922L15.8734 33.0329L15.4828 28.6313H9.93906L10.7125 37.2969L22.0188 40.4219L22.0438 40.4141V34.686Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0249 25.8891H28.8217L28.1967 33.0454L22.0405 34.7063V40.4485L33.3561 37.3125L34.8717 20.3672H22.0436L22.0249 25.8891ZM35.7186 10.6797L35.8499 9.19849H22.0217V14.7172H35.353L35.4624 13.4766L35.7186 10.6797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlLogo);
export default __webpack_public_path__ + "static/media/html-logo.70938a3267cf1760ffeed8a7a4be7de9.svg";
export { ForwardRef as ReactComponent };